export default {
    install: (app) => {
        app.config.globalProperties.$myApp = {
            // Необходима ли авторизация
            auth: {
                value: true,
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
            // Тип авторизации
            auth_type: {
                value: '',
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
            // Отображаемое имя
            name: {
                value: 'Гость',
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
            client: {
                value: '',
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
            // токен
            token: {
                value: '',
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
            // Меню
            menu: {
                options: {
                    prolongation: {
                        name: 'Пролонгация',
                        path: 'prolongation',
                    },
                    afc: {
                        name: 'Подписание договора',
                        path: 'constructor',
                    },
                    project: {
                        name: 'Индексация',
                        path: 'project',
                    },
                },
                events: [],
                value: [],
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = [];
                    for (const [key, val] of Object.entries(value)) {
                        if (val > 0) {
                            this.value.push(this.options[key]);
                        }
                    }
                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                get() {
                    return this.value
                },
            },
            // Роли
            role: {
                events: [],
                value: 'client',
                on(callback) {
                    this.events.push(callback);
                },
                set(value) {
                    value.forEach(function(val) {
                        if (val === 'pcc' || val === 'SA') {
                            this.value = 'admin';
                        }
                    }, this);
                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                get() {
                    return this.value
                },
            },
            // Подтверждены ли выкупные суммы
            ra: {
                value: false,
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
            // Ошибки
            errors: {
                events: [],
                value: [],
                on(callback) {
                    this.events.push(callback);
                },
                set(value) {
                    if (Array.isArray(value)) {
                        this.value = [];
                        this.value = value;
                    } else {
                        this.value = [];
                        this.value.push(value);
                    }

                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                get() {
                    return this.value
                },
                reset() {
                    this.value = [];
                },
            },
            // Стэк отправленных запросов
            actions: {
                events: [],
                value: [],
                on(callback) {
                    this.events.push(callback);
                },
                set(value) {
                    this.value.push(value);
                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                pullout(value) {
                    for (let i; i<this.value.length; i++) {
                        if (this.value[i] === value) {
                            delete this.value[i];
                        }
                    }
                },
                get() {
                    return this.value
                },
            },
            // Договоры клиента
            contracts: {
                events: [],
                value: [],
                on(callback) {
                    this.events.push(callback);
                },
                set(value) {
                    this.value.push(value);
                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                get() {
                    return this.value
                },
            },
            // Внутренние данные по договорам
            contract: {
                events: [],
                value: {},
                on(callback) {
                    this.events.push(callback);
                },
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                get() {
                    return this.value
                },
            },
            tech: {
                events: [],
                value: {},
                on(callback) {
                    this.events.push(callback);
                },
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(this.value);
                    })
                    // console.log(this.value);
                },
                get() {
                    return this.value
                },
            },
            // Yandex ID
            yandex_id: {
                value: '',
                events: [],
                // подписка на событие изменения авторизации
                on(callback) {
                    this.events.push(callback);
                },
                // изменение авторизацииыы
                set(value) {
                    this.value = value;
                    this.events.forEach((callback) => {
                        callback(value);
                    })
                },
                get() {
                    return this.value
                },
            },
        }
    }
}